import { render, staticRenderFns } from "./DialogEditAccount.vue?vue&type=template&id=4b738486&"
import script from "./DialogEditAccount.vue?vue&type=script&lang=js&"
export * from "./DialogEditAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports